module.exports = __webpack_public_path__ + "static/media/hiking.2eef4e78.svg";